import type { WithSpringConfig } from "@-/com.npmjs.react-native-reanimated";

/** Initial motion parameters from the plan — tune on device. */

/** From the finger's release position to the parked waiting position. */
export const LEARN_DECK_PARK_SPRING: WithSpringConfig = {
  damping: 22,
  mass: 0.7,
  overshootClamping: true,
  stiffness: 240,
};

/** From parked (or the finger) to fully off the stage. */
export const LEARN_DECK_EXIT_DURATION_MS = 260;

/**
 * Extra upward travel past the card's own height for an `up` exit. The stage sits below the
 * toolbar, so clearing the card's height alone still leaves its bottom edge under the header
 * fade; this carries it past the toolbar and the 40pt fade band with room to spare.
 */
export const LEARN_DECK_HEADER_EXIT_CLEARANCE = 160;

export const LEARN_DECK_FLIP_DURATION_MS = 300;
